import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Could not find root element to mount to');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker only in production: in dev it would serve a
// stale bundle over Vite's HMR and make every change look like it did nothing.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/app/sw.js', { scope: '/app/' }).catch((err) => {
      // Offline support is a bonus here, not a requirement — the app works
      // without it, so a registration failure is not worth surfacing.
      console.warn('Service worker registration failed:', err);
    });
  });
}
